export const investHero = {
  eyebrow: '投资与合作',
  title: '共建乡村数字经济',
  titleHighlight: '人工智能应用服务体系',
  subtitle: '九畴云市：一个已找到具体应用场景、完成 0# 首发验证的乡村数字经济项目。',
  desc: '国家政策正在推动人工智能、数字乡村、县域商业和数据要素融合，九畴云市以标准化产品矩阵驱动县域规模化复制，诚邀投资人与产业合作伙伴共建。',
};

export const marketProspect = [
  {
    icon: 'ri-line-chart-line',
    title: '乡村数字经济',
    value: '万亿级',
    desc: '乡村振兴与数字乡村战略叠加，县域与乡村数字商业基础设施需求持续释放。',
  },
  {
    icon: 'ri-store-2-line',
    title: '县域商业体系',
    value: '县乡村三级',
    desc: '县乡村三级商业体系建设，为标准化数字商业产品提供规模化的落地空间。',
  },
  {
    icon: 'ri-git-branch-line',
    title: '农产品上行',
    value: '数字化通道',
    desc: 'ePin 溯源与数字货架打通农产品数字化上行，解决销售难与信息不对称。',
  },
  {
    icon: 'ri-database-2-line',
    title: '数据要素价值',
    value: '数据链沉淀',
    desc: '一笔交易一条数据链，数据沉淀为可清分、可看板、可运营的数字资产。',
  },
];

export const businessModel = [
  {
    icon: 'ri-store-2-line',
    title: '数字货架',
    role: '交易入口',
    desc: '商品数字化上架，构成交易与数据回流的核心入口。',
  },
  {
    icon: 'ri-red-packet-line',
    title: '数字消费',
    role: '消费场景',
    desc: '红包、权益、核销构建数字消费场景，驱动用户活跃与复购。',
  },
  {
    icon: 'ri-flow-chart',
    title: '智能清分',
    role: '价值流转',
    desc: '多方协同自动结算，让平台、商户、供应链与用户七方共利。',
  },
  {
    icon: 'ri-building-2-line',
    title: '技术服务',
    role: '华辉收入',
    desc: '华辉数智通过技术交付、系统集成与运维服务获取技术服务收入。',
  },
];

export const investmentLogic = [
  {
    icon: 'ri-government-line',
    title: '政策确定性',
    desc: '契合人工智能、数字乡村、县域商业与数据要素四大国家战略方向。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '场景已验证',
    desc: '0# 帝星完成城市端验证，1# 大庄科承接乡村复制，闭环已跑通。',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '标准化复制',
    desc: 'P001–P004 小快轻准产品包，将单点样板转化为可规模化复制的底座。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '技术壁垒',
    desc: 'TOMA 智能体、ePin 数字身份、智能清分等核心技术构成差异化能力。',
  },
  {
    icon: 'ri-group-line',
    title: '生态协同',
    desc: '慈商科技、三明词元、纽盾科技、欣阳通力「1+3」联合体协同共建。',
  },
];

export const cooperation = [
  {
    icon: 'ri-funds-line',
    title: '投资合作',
    desc: '战略投资、财务投资与产业基金，共同参与九畴云市规模化建设。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '产业合作',
    desc: '供应链、渠道、品牌与技术服务方，加入乡村数字商业生态共建。',
  },
  {
    icon: 'ri-community-line',
    title: '县域合作',
    desc: '与县域政府及商业主体合作，落地数字商业基础设施与云铺网络。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '政策对接',
    desc: '对接人工智能应用服务商、服务团与相关政策申报方向。',
  },
];